import type { StringDict } from "@/i18n/ui";

const dict: StringDict = {
  "By submitting this form, you acknowledge that Catuik will process your information for the purpose stated in this form. See our":
    "Mit dem Absenden dieses Formulars nimmst Du zur Kenntnis, dass Catuik Deine Angaben für den in diesem Formular genannten Zweck verarbeitet. Weitere Informationen findest Du in unserer",
};

export default dict;
